import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { i18nInstance } from '../i18n/config'

export const LANGUAGE = 'language'

export type LocaleMapKey = 'zh-TW' | 'en-US'

export default function useLanguage() {
  const {
    i18n: { language },
  } = useTranslation()

  const isZh = useMemo(() => language.startsWith('zh'), [language])
  const languageTag: LocaleMapKey = isZh ? 'zh-TW' : 'en-US'

  const changeLanguage = useCallback((language: LocaleMapKey) => {
    i18nInstance.changeLanguage(language)
  }, [])

  const cacheLanguage = useCallback((language: LocaleMapKey) => {
    localStorage.setItem(LANGUAGE, language)
  }, [])

  const getCacheLanguage = useCallback(() => {
    return localStorage.getItem(LANGUAGE) as LocaleMapKey
  }, [])

  const clearCacheLanguage = useCallback(() => {
    localStorage.removeItem(LANGUAGE)
  }, [])

  return {
    language,
    isZh,
    languageTag,
    changeLanguage,
    cacheLanguage,
    clearCacheLanguage,
    getCacheLanguage,
  }
}
